import FormattedMessage from '../../helpers/FormattedMessage'
import UnionBlockOneImg from "../../assets/images/modal/union_design_1.png"
import UnionBlockTwoImg from "../../assets/images/modal/union_design_2.png"
import UnionBlockThreeImg from "../../assets/images/modal/union_design_3.png"
import UnionBlockFourImg from "../../assets/images/modal/union_design_4.png"


export const designOptionsStaticContentUnion = (
  <div className="static-wrapper">
    <div className="cards-wrapper">
      <div className="small-double-vertical-card">
        <img src={UnionBlockOneImg} alt="design 1"/>
        <div>
          <h3><FormattedMessage id={"ModalFourUnion.blockOne.title"}/></h3>
          <p><FormattedMessage id={"ModalFourUnion.blockOne.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={UnionBlockTwoImg} alt="design 2"/>
        <div>
          <h3><FormattedMessage id={"ModalFourUnion.blockTwo.title"}/></h3>
          <p><FormattedMessage id={"ModalFourUnion.blockTwo.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={UnionBlockThreeImg} alt="design 3"/>
        <div>
          <h3><FormattedMessage id={"ModalFourUnion.blockThree.title"}/></h3>
          <p><FormattedMessage id={"ModalFourUnion.blockThree.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={UnionBlockFourImg} alt="design 4"/>
        <div>
          <h3><FormattedMessage id={"ModalFourUnion.blockFour.title"}/></h3>
          <p><FormattedMessage id={"ModalFourUnion.blockFour.text"}/></p>
        </div>
      </div>
    </div>
  </div>
)
